import store from '@/store'
window.addEventListener("resize", function () {
  let clientWidth =
    document.documentElement.clientWidth || document.body.clientWidth;
  if (clientWidth <= 900) {
    store.commit("upAside", true);
  } else if (clientWidth > 900) {
    store.commit("upAside", false);
  }
});